/**
 * @file   : SectionDescription.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 4/15/2019, 6:25:49 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import Section, { SUB } from '../../../external/components/layout/Section'
import TextBlock from '../../../external/components/text/TextBlock'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import { getTranslation } from '../InfoUtil'

const SectionDescription = ({ intl, section, infoData }) => {
  const getSectionDescriptionUI = function () {
    let descriptionUI = null

    if (!isUndefined(section.description) && !isEmpty(section.description)) {
      const descriptionText = getTranslation(
        intl,
        section.description.token,
        section.description.default,
        infoData.infoToken,
      )
      descriptionUI = (
        <Cont className="simple-description-card__description">
          <TextBlock isHTML isDefaultHTMLStyle content={descriptionText} />
        </Cont>
      )
    }

    if (descriptionUI === null) {
      return null
    }

    return <Cont>{descriptionUI}</Cont>
  }

  const sectionDescriptionUI = getSectionDescriptionUI(section)

  if (sectionDescriptionUI === null) {
    return null
  }

  return (
    <Cont>
      <Section style={SUB}>{getSectionDescriptionUI(section)}</Section>
    </Cont>
  )
}

SectionDescription.propTypes = {
  intl: PropTypes.object.isRequired,
  section: PropTypes.object,
  infoData: PropTypes.object,
}

export default SectionDescription
